import React, { useEffect, useRef, useState } from "react";
import TruncatedTooltip from "./TruncatedTooltip";

/* Single-select com o mesmo visual do multi-select (fakeselect + popover).
   Usado em "Agrupar por" e nos combos de Mês/Ano do período. */
const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const GroupBySelect = ({ options = [], value, onChange, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickAway = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickAway);
    return () => document.removeEventListener("mousedown", handleClickAway);
  }, [open]);

  const current = options.find((o) => o.key === value) || options[0] || {};

  return (
    <div className={`dd ${open ? "open" : ""}`} ref={rootRef}>
      <div
        className={`fakeselect ${disabled ? "disabled" : ""}`}
        tabIndex={0}
        onClick={() => !disabled && setOpen((v) => !v)}
        onKeyDown={(e) => {
          if (!disabled && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            setOpen((v) => !v);
          }
        }}
        role="button"
        aria-expanded={open}
      >
        <span className="summary">
          <TruncatedTooltip text={current.label || ""} className="summary-text" />
        </span>
        <span className="ico"><ChevronIcon /></span>
      </div>
      {open && (
        <div className="dd-pop">
          {options.map((opt) => (
            <div
              key={opt.key}
              className={`dd-opt ${opt.key === value ? "on" : ""}`}
              onClick={() => {
                onChange(opt.key);
                setOpen(false);
              }}
            >
              <span className="box"><CheckIcon /></span>
              <TruncatedTooltip text={opt.label} className="dd-opt-label" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GroupBySelect;
